module.exports = __webpack_public_path__ + "static/media/tiger-queen-anthias.05f3c7f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/tiger-queen-anthias.png
// module id = 338
// module chunks = 0